export default {
  titles: {
    pickup: 'Ritiro',
    delivery: 'Consegna',
  },
  buttons: {
    confirm: 'Conferma',
  },
};
